import React from 'react'
import { format } from 'date-fns'

const usePush = () => {

    // Can use this function below, OR use Expo's Push Notification Tool-> https://expo.dev/notifications
    async function _sendPushNotification(expoPushToken,titlePush,messagePush) {
        // const myInt = parseInt('ExponentPushToken[I88p4GCSIKKuXlYNBP7sQE]')

        const message = {
            to: 'ExponentPushToken[' + expoPushToken + ']',
            sound: 'default',
            title: titlePush,
            body: messagePush,
            data: { someData: 'goes here' },
        }; 
    
        await fetch('https://exp.host/--/api/v2/push/send', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Accept-encoding': 'gzip, deflate',
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin':'*',
            },
            body: JSON.stringify(message),
            mode:'no-cors',
        })

        // console.log('usePush _sendPushNotification ', expoPushToken, titlePush, messagePush)
    }

    const _sendPushClientBooking = (date,expoPushToken,titlePush,messagePush) => {
        // recuperation de la date actuelle 
        const currentDate = format(new Date(Date.now()), 'MM/dd/yyyy')
        // conversion de la date actuelle en int (sans les heures)
        const currentDateInt = new Date(currentDate).getTime()
        // affichage de la date choisie en int
        const choiceDateInt = new Date(date).getTime()
        // si la date actuelle est inférieur lancer le message push
        if (currentDateInt < choiceDateInt) {
            let number = (choiceDateInt - currentDateInt) + 25200000
            setTimeout(() => {
                _sendPushNotification(expoPushToken,titlePush,messagePush)
            },number)
        }
    }

    return { _sendPushNotification, _sendPushClientBooking }
}

export default usePush 